<template>
  <div class="login-container">
		<div :style="bgBox">
			<div class="logintitle"></div>
				<div class="loginpanel">
					<div style=" height:250px; margin-top:15px;">
						<div class="logininput">
							<img src="../../static/img/yhm.png"></img>
							<input type="text" placeholder="请输入用户名" v-model="userName" />
						</div>
						<div class="logininput">
							<img src="../../static/img/mm.png" />
							<input id="textBox_Password" type="password" placeholder="请输入密码"  v-model="passWord" />
						</div>
						<div class="loginbutton" @click="login">登&nbsp;&nbsp;录</div>
					</div>
				</div>
				<div style="color:#333;font-size:14px;width: 100%;text-align: center;position: fixed;bottom: 10px;">
					<div>长沙华售信息科技有限公司版权所有<div>
					<div>湘ICP备2020016861号</div>
				</div>
			</div>
		</div>
		</div>
  </div>
</template>

<script>

export default {
  name: 'Login',
  data() {
    return {
      bgBox:{
				'background': "url(" + require("../../static/img/login-bg1.jpg")+ ") no-repeat center center",
				'height': "100vh",
				'backgroundSize': 'cover',
				'boxSizing': 'border-box'
			},
			userName: '',
			passWord: '',
    }
  },
  methods: {
    login(){
			if(!this.userName) return alert("请输入用户名");
			if(!this.passWord) return alert("请输入密码");
			if(this.userName=='123' && this.passWord=='123'){
				this.$router.push('/map');
			}else{
				alert("账号或密码错误！");
			}
		}
  }
}
</script>

<style>
	*{ box-sizing: border-box; }
	html, body { height: 100%; }
	.bg-box{
		height:100%;
		background-size:cover;
	}
	.logintitle {
	  font-size: 28px;
	  position: absolute;
	  font-weight: bold;
	  color: #ffffff;
	  top: 90px;
	  width: 100%;
	  letter-spacing: 8px;
	  text-align: center;
	  text-shadow: 2px 3px 4px #444444;
	}
	.loginpanel {
	  width: 280px;
	  height: 270px;
	  margin: auto;
	  position: absolute;
	  top: 0;
	  left: 0;
	  bottom: 0;
	  right: 34%;
	  -moz-border-radius: 10px 10px 10px 10px;
	  -webkit-border-radius: 10px 10px 10px 10px;
	  border-radius: 10px 10px 10px 10px;
	  padding: 10px;
	}
	.logintext {
	  width: 100%;
	  text-align:center;
	  height: 40px;
	  font-weight:bold;
		color: #418ac5;
	  font-size:23px;
	}
	.logininput {
	  width: 100%;
	  height: 35px;
	  line-height: 35px;
	  border: 1px solid rgb(220,227,229);
	  margin-bottom: 25px;
	  background-color: #ffffff;
	  padding: 0 10px;
		border-radius: 6px;
		display: flex;
		align-items: center;
		background: #f5f5f5;
	}
	.logininput img {
	  height: 16px;
	  width: 16px;
	  display: inline-block;
		margin-right: 6px;
	}
	.logininput input {
	  border: 0px;
	  outline-style: none;
	  height: 30px;
	  width: 200px;
	  margin: 0px;
	  display: inline-block;
	  float: right;
	  font-size: 14px;
	  color: rgb(108,108,108);
		background: #f5f5f5;
	}
	.loginbutton {
	  color: rgb(234,236,247);
	  background-color: rgb(1,100,201);
	  width: 100%;
	  text-align: center;
	  height: 40px;
	  font-weight: bold;
	  line-height: 40px;
		color: #fff;
		background: #418ac5;
	  font-size: 16px;
	  cursor:pointer;
		border-radius: 6px;
		box-shadow: 2px 3px 4px #237CC3;
	}
	input:-internal-autofill-selected {
	    appearance: menulist-button;
	    background-image: none !important;
	    background-color: -internal-light-dark(rgb(232, 240, 254), rgba(70, 90, 126, 0.4)) !important;
	    color: fieldtext !important;
	}
	
</style>
